import Vue from 'vue'

const auditEntityPublicFunds = {
  state: {
    auditEntityPublicFunds: [],
    selectedAuditEntityPublicFunds: {},
  },

  getters: {
    auditEntityPublicFunds(state) {
      return state.auditEntityPublicFunds
    },
    selectedAuditEntityPublicFunds(state) {
      return state.selectedAuditEntityPublicFunds
    },
  },

  mutations: {
    auditEntityPublicFunds(state, payload) {
      state.auditEntityPublicFunds = payload
    },
    selectedAuditEntityPublicFunds(state, payload) {
      state.selectedAuditEntityPublicFunds = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedAuditEntityPublicFunds(context, payload) {
      context.commit('selectedAuditEntityPublicFunds', payload)
    },
    loadAuditEntityPublicFunds(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'AuditEntityPublicFunds'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('auditEntityPublicFunds', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedAuditEntityPublicFunds(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'AuditEntityPublicFunds/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedAuditEntityPublicFunds', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateAuditEntityPublicFunds(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `AuditEntityPublicFunds/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'auditEntityPublicFunds updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadAuditEntityPublicFunds')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createAuditEntityPublicFunds(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `AuditEntityPublicFunds`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'auditEntityPublicFunds created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadAuditEntityPublicFunds')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveAuditEntityPublicFunds(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateAuditEntityPublicFunds', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createAuditEntityPublicFunds', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteAuditEntityPublicFunds(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `AuditEntityPublicFunds/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'auditEntityPublicFunds deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadAuditEntityPublicFunds')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default auditEntityPublicFunds
